<!--
/*******************************************************************************
*@ 컴포넌트명   : CorporationInfo2.vue
*@ 컴포넌트설명 : 고객정보조회/변경 - 확인 [기업]
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section class="corporation">
    <nos-component ref="NOS_COMPONENT" :component="this.NOS_INSTANCE.components" />
    <div class="scroll">
      <contents-header :bg-type="true" title="MCOP-01-01-07-01" description="MCOP-01-01-07-02" />
      <article class="contents">
        <div class="form">
          <!-- 기업명 -->
          <div class="form-row">
            <input-text
              ref="ovsesCustOcntryName"
              id="ovsesCustOcntryName"
              :value="RBF0409E40_data.ovsesCustOcntryName"
              disabled
              label-i18n="MCOP-01-01-07-03"
            />
          </div>
          <!-- 회사 전화번호 -->
          <div class="form-row">
            <input-text
              ref="coTelno"
              id="coTelno"
              :value="RBF0409E40_data.coTelno"
              disabled
              label-i18n="MCOP-01-01-07-04"
            />
          </div>
          <!-- 팩스번호 -->
          <div class="form-row">
            <input-text
              ref="faxNo"
              id="faxNo"
              :value="RBF0409E40_data.faxNo"
              disabled
              label-i18n="MCOP-01-01-07-05"
            />
          </div>
          <!-- 법인소재지주소 -->
          <div class="form-row">
            <div class="item-tit">{{ /*법인소재지주소*/ $t("MCOP-01-01-07-06") }}</div>
            <div class="item-desc">
              <input-text
                v-if="RBF0409E40_data.coprNmad"
                ref="coprNmad"
                id="coprNmad"
                :value="RBF0409E40_data.coprNmad"
                disabled
              />
              <input-text
                ref="coprAddr1"
                id="coprAddr1"
                :value="RBF0409E40_data.coprAddr1"
                disabled
              />
              <input-text
                v-if="RBF0409E40_data.coprAddr2"
                ref="coprAddr2"
                id="coprAddr2"
                :value="RBF0409E40_data.coprAddr2"
                disabled
              />
              <input-text
                v-if="RBF0409E40_data.coprAddr3"
                ref="coprAddr3"
                id="coprAddr3"
                :value="RBF0409E40_data.coprAddr3"
                disabled
              />
            </div>
          </div>
          <!-- 대표자명 -->
          <div class="form-row">
            <input-text
              ref="rprsOcntryName"
              id="rprsOcntryName"
              :value="RBF0409E40_data.rprsOcntryName"
              disabled
              label-i18n="MCOP-01-01-07-07"
            />
          </div>
          <!-- 대표자 휴대폰번호 -->
          <div class="form-row">
            <input-text
              ref="cphnNo"
              id="cphnNo"
              :value="RBF0409E40_data.cphnNo"
              disabled
              label-i18n="MCOP-01-01-07-08"
            />
          </div>
          <!-- 내선번호 -->
          <div class="form-row">
            <input-text
              ref="exno"
              id="exno"
              :value="RBF0409E40_data.exno"
              disabled
              label-i18n="MCOP-01-01-07-09"
            />
          </div>
          <!-- 이메일 주소 -->
          <div class="form-row">
            <input-text
              ref="rprsEmad1"
              id="rprsEmad1"
              :value="RBF0409E40_data.rprsEmad1"
              disabled
              label-i18n="MCOP-01-01-07-10"
            />
          </div>
          <!-- 대표자 주소 -->
          <div class="form-row">
            <div class="item-tit">{{ /*대표자 주소*/ $t("MCOP-01-01-07-11") }}</div>
            <div class="item-desc">
              <input-text
                v-if="RBF0409E40_data.rprsNmad"
                ref="rprsNmad"
                id="rprsNmad"
                :value="RBF0409E40_data.rprsNmad"
                disabled
              />
              <input-text
                ref="rprsAddr1"
                id="rprsAddr1"
                :value="RBF0409E40_data.rprsAddr1"
                disabled
              />
              <input-text
                v-if="RBF0409E40_data.rprsAddr2"
                ref="rprsAddr2"
                id="rprsAddr2"
                :value="RBF0409E40_data.rprsAddr2"
                disabled
              />
              <input-text
                v-if="RBF0409E40_data.rprsAddr3"
                ref="rprsAddr3"
                id="rprsAddr3"
                :value="RBF0409E40_data.rprsAddr3"
                disabled
              />
            </div>
          </div>
          <!-- 우편물 수신 -->
          <div class="form-row">
            <input-text
              ref="postSendAreaDstcd"
              id="postSendAreaDstcd"
              :value="$te(RBF0409E40_data.postSendAreaDstcd+'_우편발송지구분코드')?$t(RBF0409E40_data.postSendAreaDstcd+'_우편발송지구분코드'):''"
              disabled
              label-i18n="MCOP-01-01-07-12"
            />
          </div>
          <!-- 거래 Statement 우편발송 여부 -->
          <div v-if="siteCode===$config.SITECODE_OGAUC" class="form-row">
            <input-text
              ref="postSendYn"
              id="postSendYn"
              :value="$te(RBF0409E40_data.postSendYn+'_우편발송여부')?$t(RBF0409E40_data.postSendYn+'_우편발송여부'):''"
              disabled
              label-i18n="MCOP-01-01-07-14"
            />
            <div
              v-if="siteCode===$config.SITECODE_OGAUC"
              class="info info-etc"
            >※ {{ /*조회 > 거래내역조회 > Statement조회 에서 조회 후 인쇄할 수 있습니다.*/ $t("MCOP-01-01-07-16") }}</div>
          </div>
        </div>

        <div class="notice notice-box--type">
          <div class="notice-tit">
            <p class="bullet">{{ /*유의사항*/ $t("MCOP-01-01-07-17") }}</p>
          </div>
          <div class="notice-cont">
            <ul class="ulist bar">
              <li>- {{ /*잘못된 정보로 인한 우편물 반송에 대한 책임은 당사자가 지지 않습니다.*/ $t("MCOP-01-01-07-18") }}</li>
            </ul>
          </div>
        </div>
      </article>
    </div>
    <div class="btn-area--full fixed">
      <button class="btn md normal" @click="goNextStep">{{ /*확인*/ $t("MCOM-0000003") }}</button>
    </div>
    <approval-line ref="otp" :NOS_INSTANCE_REFERANCE="NOS_INSTANCE" @authOpen="confirmOtp" />
  </section>
</template>
<script>
import ApprovalLine from "@/components/page/common/ApprovalLine";
import NOSComponent from "@/components/page/pluginFree/NOSComponent";
import NOSController from "@/components/page/pluginFree/NOSController";
import Common from "@/components/basic/Common";
import { mapFields } from "vuex-map-fields";

export default {
  extends: Common,
  components: {
    "nos-component": NOSComponent,
    ApprovalLine,
  },
  computed: {
    ...mapFields("admin/personalInfo", ["RBF0409E40_data"]),
  },
  mounted() {
    this.NOS_INSTANCE.init();
  },
  data() {
    return {
      NOS_INSTANCE: new NOSController(this, {
        componentid: "NOS_COMPONENT",
        kpd: true,
      }),
    };
  },
  methods: {
    RBF0509F50Call() {
      let params = {
        inquryCoTelno: this.RBF0409E40_data.coTelno,
        inquryFaxNo: this.RBF0409E40_data.faxNo,
        inquryCphnNo: this.RBF0409E40_data.cphnNo,
        inquryExno: this.RBF0409E40_data.exno,
        inquryEmad2: this.RBF0409E40_data.rprsEmad1,
        inquryCoprNmad: this.RBF0409E40_data.coprNmad,
        inquryCoprAddr1: this.RBF0409E40_data.coprAddr1,
        inquryCoprAddr2: this.RBF0409E40_data.coprAddr2,
        inquryCoprAddr3: this.RBF0409E40_data.coprAddr3,
        inquryRprsNmad: this.RBF0409E40_data.rprsNmad,
        inquryRprsAddr1: this.RBF0409E40_data.rprsAddr1,
        inquryRprsAddr2: this.RBF0409E40_data.rprsAddr2,
        inquryRprsAddr3: this.RBF0409E40_data.rprsAddr3,
        inquryPostSendAreaDstcd: this.RBF0409E40_data.postSendAreaDstcd,
        inquryPostSendYn: this.RBF0409E40_data.postSendYn,
        _nprotected: this.NOS_INSTANCE.toJSON(),

        commAuth: { biz: this.$config.AUTH_01, bizParam: {} },
      };

      this.$post("/customer/cust/CustInfoUpt3", params, this.RBF0509F50Suc);
    },
    RBF0509F50Suc() {
      this.$router.push({ name: "perInfoStep3Corp" });
    },
    goNextStep() {
      this.$refs.otp.open();
    },
    confirmOtp() {
      this.RBF0509F50Call();
    },
  },
};
</script>